import { Form } from 'antd'
import { useEffect } from 'react'
import WizrInput from '../WizrInput'
import WizrFlexSpacing from '../WizrFlexSpacing'
import WizrButton from '../WizrButton'
import WizrFlexLayout from '../WizrFlexLayout'
import { styled } from 'styled-components'
import { useContentLoadingSelector, useTenantTeamSelectors } from '../../redux/selectors/content'

const StyledContainer = styled(WizrFlexLayout)`
  gap: 8px;
`

interface ICreateTeam {
  name?: string
  onFormSubmission: (params: { [key: string]: any }) => void
  onCancel: () => void
}


const CreateTeam = ({
  name,
  onFormSubmission,
  onCancel,
}: ICreateTeam): JSX.Element => {
  const [form] = Form.useForm()
  const teams= useTenantTeamSelectors()
const loading = useContentLoadingSelector()
  useEffect(() => {
    form.setFieldValue('currentname', name)
  }, [name])
  return (
    <StyledContainer background='#FFF' justifyContent='space-evenly'>
      <Form
        name='basic'
        form={form}
        initialValues={{ remember: true }}
        onFinish={onFormSubmission}
        onFinishFailed={() => null}
        autoComplete='off'
      >
        <Form.Item
          name='currentname'
          rules={[
            { required: true, message: 'Please Enter a Folder Name', whitespace: true },
            {
              validator: (_, value) => {
                const teamExists = teams?.some(
                  (item: any) => value?.replace(/\s+/g, '').toLowerCase() === item?.team_key
                );
                if (teamExists) {
                  return Promise.reject(new Error('Team name already exists'));
                }
                return Promise.resolve();
              }
            }
          ]}
        >
          <WizrInput
            placeholder='Enter Name'
            onChange={(value: string) => form.setFieldsValue({ currentname: value })}
          />
        </Form.Item>
       
        <Form.Item>
          <WizrFlexSpacing
            justifyContent='flex-end'
            flexDirection='row'
            size='large'
            background='#FFF'
          >
            <WizrButton type='default' text='Cancel' onClick={onCancel} style={{borderRadius: '20px'}}/>
            <WizrButton htmlType='submit' text={'Create'} disabled={loading} style={{borderRadius: '20px'}}/>
          </WizrFlexSpacing>
        </Form.Item>
      </Form>
    </StyledContainer>
  )
}

export default CreateTeam
